import type * as Types from '~/gql/graphql';

import { gql } from 'urql';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UserFragment = { id: string, full_name?: string | null, is_connected: boolean, user_avatar?: { public_url: string } | null, active_org?: { org: { name: string, id: string, org_avatar?: { public_url: string } | null } } | null, contact?: { id?: string | null, email?: string | null, phone?: string | null } | null, metadatas?: { placeholder_company_name?: string | null } | null, connections: Array<{ created_at: string }> };

export type UserProfileContainer_DataQueryVariables = Types.Exact<{
  userId: Types.Scalars['uuid']['input'];
}>;


export type UserProfileContainer_DataQuery = { users_by_pk?: { id: string, full_name?: string | null, is_connected: boolean, user_avatar?: { public_url: string } | null, active_org?: { org: { name: string, id: string, org_avatar?: { public_url: string } | null } } | null, contact?: { id?: string | null, email?: string | null, phone?: string | null } | null, metadatas?: { placeholder_company_name?: string | null } | null, connections: Array<{ created_at: string }> } | null };

export type UserProjectInfo_DataQueryVariables = Types.Exact<{
  projectId: Types.Scalars['uuid']['input'];
  userId: Types.Scalars['uuid']['input'];
}>;


export type UserProjectInfo_DataQuery = { projects_by_pk?: { id: string, name: string, members: Array<{ created_at: string, role: { name: string }, user: { first_name: string, last_name: string, is_active: boolean, id: string, full_name?: string | null, is_connected: boolean, teams: Array<{ team_id: string, team: { name: string, color: string } }>, metadatas?: { placeholder_company_name?: string | null } | null, user_avatar?: { public_url: string } | null, active_org?: { org: { name: string, id: string, org_avatar?: { public_url: string } | null } } | null, contact?: { id?: string | null, email?: string | null, phone?: string | null } | null, connections: Array<{ created_at: string }> }, inviter?: { id: string, full_name?: string | null, user_avatar?: { public_url: string } | null } | null }> } | null };

export const UserFragmentDoc = gql`
    fragment User on users {
  id
  full_name
  is_connected
  user_avatar {
    public_url
  }
  active_org {
    org {
      name
      id
      org_avatar {
        public_url
      }
    }
  }
  contact {
    id
    email
    phone
  }
  metadatas {
    placeholder_company_name
  }
  connections(order_by: {created_at: desc}, limit: 1) {
    created_at
  }
}
    `;
export const UserProfileContainer_DataDocument = gql`
    query UserProfileContainer_data($userId: uuid!) {
  users_by_pk(id: $userId) {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useUserProfileContainer_DataQuery(options: Omit<Urql.UseQueryArgs<UserProfileContainer_DataQueryVariables>, 'query'>) {
  return Urql.useQuery<UserProfileContainer_DataQuery, UserProfileContainer_DataQueryVariables>({ query: UserProfileContainer_DataDocument, ...options });
};
export const UserProjectInfo_DataDocument = gql`
    query UserProjectInfo_data($projectId: uuid!, $userId: uuid!) {
  projects_by_pk(id: $projectId) {
    id
    name
    members(where: {user: {id: {_eq: $userId}}}) {
      role {
        name
      }
      user {
        ...User
        first_name
        last_name
        teams(where: {team: {project_id: {_eq: $projectId}}}) {
          team_id
          team {
            name
            color
          }
        }
        is_active
        metadatas {
          placeholder_company_name
        }
      }
      inviter {
        id
        user_avatar {
          public_url
        }
        full_name
      }
      created_at
    }
  }
}
    ${UserFragmentDoc}`;

export function useUserProjectInfo_DataQuery(options: Omit<Urql.UseQueryArgs<UserProjectInfo_DataQueryVariables>, 'query'>) {
  return Urql.useQuery<UserProjectInfo_DataQuery, UserProjectInfo_DataQueryVariables>({ query: UserProjectInfo_DataDocument, ...options });
};